import axios from "axios";
import Swal from "sweetalert2";

export const handleICICIPayment = async ({
  amount,
  user,
  orderData,
  onFail,
}) => {
  try {
    // 1. Fetch redirect URL from our backend
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_URL}/icici/create-payment`,
      {
        amount: amount, 
        name: user?.firstName || "Guest",
        email: user?.email || "guest@example.com",
        number: user?.phone || "0000000000",
        orderData: orderData
      }
    );

    if (!data.success || !data.redirectUrl) {
      Swal.fire("Error", "Unable to initiate ICICI payment", "error");
      if (onFail) onFail();
      return;
    }

    // 2. Simply redirect the browser to the ICICI Payment Gateway
    window.location.href = data.redirectUrl;

  } catch (err) {
    console.error("ICICI Payment Error:", err);
    Swal.fire("Error", "Something went wrong while initiating ICICI payment", "error");
    if (onFail) onFail();
  }
};
